import React, { memo, useEffect, useMemo, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logoImg from "../../public/assets/images/logo.svg";

import styles from "../../styles/components/htmltoPdf.module.scss";
import assest from "../../json/assest";
import { useQuery } from "react-query";
import axiosInstance from "../../api/axiosInstance";

const ContentBuyerHtmlToPdfConverter = ({
  user_id = null,
  month = "",
  year = null,
  id,
  name,
}) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [paymentRequestData, setPaymentRequestData] = useState([]);

  const [enable, setEnable] = useState(false);
  const [enable1, setEnable1] = useState(false);
  const [enable2, setEnable2] = useState(false);

  const [click, setClick] = useState(false);

  function formatDateRange(month, year) {
    if (month !== undefined && year !== undefined) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const monthIndex = monthNames.findIndex(
        (monthName) => monthName.toLowerCase() === month.toLowerCase()
      );

      if (monthIndex !== -1) {
        let lastDay = 31; // Default to 31 days

        if (monthIndex === 1) {
          // February
          if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            lastDay = 29;
          } else {
            lastDay = 28;
          }
        } else if ([3, 5, 8, 10].includes(monthIndex)) {
          lastDay = 30;
        }

        const formattedDateRange = `${year}/${(monthIndex + 1)
          .toString()
          .padStart(2, "0")}/01 to: ${year}/${(monthIndex + 1)
          .toString()
          .padStart(2, "0")}/${lastDay.toString().padStart(2, "0")}`;
        return {
          start_date: `${year}-${(monthIndex + 1)
            .toString()
            .padStart(2, "0")}-01`,
          end_date: `${year}-${(monthIndex + 1)
            .toString()
            .padStart(2, "0")}-${lastDay.toString().padStart(2, "0")}`,
        };
      } else {
        return "Invalid month";
      }
    } else {
      return "Invalid input";
    }
  }

  const { data } = useQuery(
    ["paymentData", enable, month, year, user_id],
    async () => {
      return await axiosInstance.get(
        `admin/get-payemt-request?user_id=${user_id}&from=${
          formatDateRange(month, year).start_date
        }&to=${formatDateRange(month, year).end_date}`
      );
    },
    {
      enabled: !!user_id && !!month && !!year && enable,
      onSuccess: (data) => {
        console.warn("data", data);
        Object.entries(data.data.data).map(([month, items]) =>
          setPaymentRequestData(items)
        );
        setEnable1(true);
      },
    }
  );

  const { data: videoData } = useQuery(
    ["videoData", enable1, month, year, user_id],
    async () => {
      return await axiosInstance.post(
        `admin/videos?buyer_id=${user_id}&from=${
          formatDateRange(month, year).start_date
        }&to=${formatDateRange(month, year).end_date}`
      );
    },
    {
      enabled: !!user_id && !!month && !!year && enable1,
      onSuccess: (data) => {
        console.warn("videoData", data);
        setEnable2(true);
      },
    }
  );

  const { data: contentBuyerSubmissionsData } = useQuery(
    ["contentBuyerSubmissionsData", enable2, month, year, user_id],
    async () => {
      return await axiosInstance.post(
        `admin/submissions?buyer_id=${user_id}&from=${
          formatDateRange(month, year).start_date
        }&to=${formatDateRange(month, year).end_date}`
      );
    },
    {
      enabled: !!user_id && !!month && !!year && enable2,
      onSuccess: (data) => {
        console.warn("contentBuyerSubmissionsData", data);
        setClick(true);
      },
    }
  );

  useEffect(() => {
    if (click) {
      convertToPdf();
      setClick(false);
      setEnable(false);
      setEnable1(false);
      setEnable2(false);
    }
  }, [click]);

  const convertToPdf = async () => {
    const content = document.createElement("div");
    content.innerHTML = `
    <table style="
    width: 100%;
    max-width: 1200px;
    border-spacing: 0px;
    margin: 0 auto;
    padding: 0px;
    font-weight: normal;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: #000;
    background-color: #fff;
  ">
  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          border-bottom: 1px solid #f2f2f2;
          padding: 30px 50px;
          font-size: 16px;
          color: #272727;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
        ">
        <tr>
          <td style="padding: 0">
            <img src=${logoImg} alt="" />
          </td>
          <td style="
              font-size: 16px;
              color: #393939;
              font-weight: 500;
              text-align: center;
              padding: 0 15px;
            ">
            Content Buyer:
            <span style="color: #000; font-weight: 500">${name}</span>
          </td>
          <td style="text-align: right; padding: 0">${month} ${year} Report</td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          font-size: 13px;
          color: #5f5f5f;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
          padding: 25px 50px 88px 50px;
          border-bottom: 1px solid #f2f2f2;
        ">
        <tr>
          <td style="
              padding: 0;
              font-size: 16px;
              line-height: 1.2;
              color: #000;
              font-weight: 600;
              padding-bottom: 44px;
            ">
            Payments Breakdown
          </td>
        </tr>

        <tr>
          <td>
            <table style="width: 100%; max-width: 494px; margin: 0 auto">
              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount of purchases
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  ${
                    contentBuyerSubmissionsData?.data?.data?.accounting
                      ?.total_purchase
                      ? `$ ${contentBuyerSubmissionsData?.data?.data?.accounting?.total_purchase}`
                      : "-"
                  }
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount requested
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  ${
                    contentBuyerSubmissionsData?.data?.data?.accounting
                      ?.request_amount
                      ? `$ ${contentBuyerSubmissionsData?.data?.data?.accounting?.request_amount}`
                      : "-"
                  }
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount paid
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #00234c;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  ${
                    contentBuyerSubmissionsData?.data?.data?.accounting
                      ?.paid_amount
                      ? `$ ${contentBuyerSubmissionsData?.data?.data?.accounting?.paid_amount}`
                      : "-"
                  }
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount received
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #004804;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  ${
                    contentBuyerSubmissionsData?.data?.data?.accounting
                      ?.recived_amount
                      ? `$ ${contentBuyerSubmissionsData?.data?.data?.accounting?.recived_amount}`
                      : "-"
                  }
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                  ">
                  Total amount owed
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #531111;
                    padding-left: 10px;
                  ">
                  ${
                    contentBuyerSubmissionsData?.data?.data?.accounting
                      ?.outstading_balance
                      ? `$ ${contentBuyerSubmissionsData?.data?.data?.accounting?.outstading_balance}`
                      : "-"
                  }
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          font-size: 13px;
          color: #5f5f5f;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
          padding: 25px 50px 88px 50px;
          border-bottom: 1px solid #f2f2f2;
        ">
        <tr>
          <td style="
              padding: 0;
              font-size: 16px;
              line-height: 1.2;
              color: #000;
              font-weight: 600;
              padding-bottom: 42px;
            ">
            Payments History
          </td>
        </tr>

        <tr>
          <td>
            <table style="width: 100%; padding: 0 84px">
              <thead>
                <tr>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Amount Requested
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    PayPal
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Amount Paid
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Amount Received
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Payment Receipt
                  </th>
                </tr>
              </thead>
              

              <tbody>
              ${paymentRequestData.map(
                (item) =>
                  `<tr>
                  <td
                    style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 180px;
                    "
                  >
                    ${item?.request_amount ? `$${item?.request_amount}` : ""}
                    <span
                      style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      "
                    >
                      ${new Date(item?.created_at).toLocaleDateString("en-US", {
                        weekday: "long",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                  </td>

                  <td
                    style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 190px;
                    "
                  >
                    <a
                      href="#url"
                      style="color: #5f5f5f;text-decoration: none;"
                    >
                      ${item?.paypal_email?.toString()}
                    </a>
                  </td>

                  <td
                    style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    "
                  >
                    ${item?.paid_amount ? `$${item?.paid_amount}` : ""}
                    <span
                      style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      "
                    >
                      ${new Date(item?.created_at).toLocaleDateString("en-US", {
                        weekday: "long",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                  </td>

                  <td
                    style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    "
                  >
                    ${item?.recived_amount ? `$${item?.recived_amount}` : ""}
                  </td>

                  <td
                    style="
                      padding: 0;
                      padding-right: 0;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    "
                  >
                    <a
                      href=${`https://vsclips.s3.us-east-2.amazonaws.com/${item.admin_recipt}`}
                      style="
                        font-weight: 500;
                        color: #20c;
                        text-decoration: underline;
                      "
                    >
                      receipt.png
                    </a>
                  </td>
                </tr>`
              )}
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          font-size: 13px;
          color: #5f5f5f;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
          padding: 90px 50px 85px 50px;
          border-bottom: 1px solid #f2f2f2;
        ">
        <tr>
          <td style="
              padding: 0;
              font-size: 16px;
              line-height: 1.2;
              color: #000;
              font-weight: 600;
              padding-bottom: 26px;
            ">
            Purchased Videos
            <span style="
                background: #f8f8f8;
                border-radius: 11px;
                padding: 8px 15px;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.2;
                color: #000;
                margin-left: 15px;
                display: inline-block;
                vertical-align: middle;
              ">${videoData?.data?.total ? videoData?.data?.total : ""}</span>
          </td>
        </tr>

        <tr>
          <td>
            <table style="width: 100%; padding: 0 103px; border-spacing: 0">
              <thead>
                <tr>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 75px;
                      border-radius: 14px 0 0 0;
                    ">
                    VSID
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 100px;
                    ">
                    Owner Name
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 130px;
                    ">
                    Email Address
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 110px;
                    ">
                    Purchase Date
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 100px;
                      border-radius: 0 14px 0 0;
                      text-align: right;
                    ">
                    Purchase Amount 
                  </th>
                </tr>
              </thead>

              <tbody>
              ${videoData?.data?.data?.map((item) => {
                return `<tr>
                    <td
                      style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    "
                    >
                      ${item?.vsid ? `#${item?.vsid}` : ""}
                    </td>
                    <td
                      style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    "
                    >
                      ${item?.first_name} ${item?.last_name}
                    </td>
                    <td
                      style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    "
                    >
                      <a
                        href="mailto:johnsmith@gmail.com"
                        style="color: #6c6868; text-decoration: none"
                      >
                        ${item?.email}
                      </a>
                    </td>
                    <td
                      style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    "
                    >
                      ${new Date(item?.created_at).toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </td>
                    <td
                      style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    "
                    >
                      ${item?.price ? `$${item?.price}` : ""}
                    </td>
                  </tr>`;
              })}              
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0;">
      <table style="width: 100%;border-bottom: 1px solid #F2F2F2;padding: 25px 50px;">
        <tr>
          <td
            style="padding: 0;text-align: center;color: #A1A1A1;font-size: 14px;line-height: 1.2;font-weight: 400;">
            Have any questions or need assistance? Please reach out to our team at <a href="info@viralsnare.com"
              style="color: #A1A1A1;text-decoration: none;">info@viralsnare.com</a></td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0;">
      <table style="width: 100%;padding: 33px 50px;">
        <tr>
          <td style="padding: 0;text-align: center;">
            <span
              style="font-size: 24px;line-height: 1.2;font-weight: 500;color: #000;background: #F6F6F6;border-radius: 14px;display: inline-block;min-width: 394px;text-align: center;padding: 21px 20px;">SEE
              YOU NEXT MONTH :D</span>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    `;
    content.style.position = "absolute";
    content.style.left = "-9999px";
    document.body.appendChild(content);
    const pdf = new jsPDF({
      unit: "mm", // Use millimeters as the unit for dimensions
      format: [216, 400], // Set custom page dimensions
    });
    // const content = document.getElementById("contentToConvert");
    // const content = pdftable()
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      setPreviewImage(imgData);
      pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
      pdf.save("Form.pdf");
      document.body.removeChild(content);
    });
  };

  return (
    <div>
      <button onClick={() => setEnable(true)}>
        {" "}
        <img src={assest.downloadReportIcon} width={17} height={15} alt="" />
      </button>

      {/* {previewImage && (
        <div>
          <h2>Preview Image:</h2>
          <img src={previewImage} alt="PDF Preview" />
        </div>
      )} */}
    </div>
  );
};

export default memo(ContentBuyerHtmlToPdfConverter);
